import { render, staticRenderFns } from "./Ticker.vue?vue&type=template&id=bc4f1954&scoped=true&"
import script from "./Ticker.vue?vue&type=script&lang=js&"
export * from "./Ticker.vue?vue&type=script&lang=js&"
import style0 from "./Ticker.vue?vue&type=style&index=0&id=bc4f1954&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4f1954",
  null
  
)

export default component.exports